import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Folder, FileText, CheckCircle2, AlertCircle, Clock } from "lucide-react";

/** Compact stats bar shown on the Projects tab. */
export default function StatsBar() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/analytics/summary").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return null;

  const items = [
    { icon: Folder,        label: "Projects",   value: stats.projects,   accent: "text-[#93C5FD]" },
    { icon: FileText,      label: "Drafts",     value: stats.documents,  accent: "text-white" },
    { icon: CheckCircle2,  label: "Complete",   value: stats.complete,   accent: "text-emerald-300" },
    { icon: AlertCircle,   label: "Truncated",  value: stats.truncated,  accent: "text-amber-300" },
  ];

  return (
    <div className="mb-10 grid gap-px bg-slate-100 sm:grid-cols-2 lg:grid-cols-5" data-testid="stats-bar">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <div key={it.label} className="flex items-center justify-between bg-white px-5 py-4">
            <div>
              <div className="overline mb-1 text-slate-400">{it.label}</div>
              <div className={`font-serif text-2xl font-semibold ${it.accent}`}>{it.value ?? 0}</div>
            </div>
            <Icon className="h-5 w-5 text-slate-300" strokeWidth={1.5} />
          </div>
        );
      })}
      <div className="col-span-2 flex items-center justify-between bg-white px-5 py-4 lg:col-span-1">
        <div className="min-w-0">
          <div className="overline mb-1 text-slate-400">Last activity</div>
          {stats.last_activity ? (
            <>
              <div className="text-sm font-medium text-slate-900">
                {new Date(stats.last_activity).toLocaleDateString(undefined, {
                  month: "short", day: "numeric", year: "numeric",
                })}
              </div>
              {stats.last_title && (
                <div className="mt-0.5 truncate text-xs text-slate-500" title={stats.last_title}>
                  {stats.last_title}
                </div>
              )}
            </>
          ) : (
            <div className="text-sm text-slate-400">No activity yet</div>
          )}
        </div>
        <Clock className="ml-3 h-5 w-5 shrink-0 text-slate-300" strokeWidth={1.5} />
      </div>
    </div>
  );
}
